export const typedWord = (word: string, callback: (word: string, end: boolean, duration?: number) => void, { speed = 200, forwards = true } = {}) => {
  let part = ''
  const len = word.length
  let offset = forwards ? 0 : len
  // let skipCount = 0
  // let skipDelay = 15
  let startTime = 0
  let beginTime = 0
  let frameId = null
  const control: { stop: boolean } = { stop: false }

  const step = (timestamp: number) => {
    if (control.stop) {
      window.cancelAnimationFrame(frameId)
      callback?.(null, false)
      return
    }
    if (!beginTime) {
      beginTime = timestamp
      startTime = timestamp
    }
    const split = timestamp - beginTime
    if (split && split < speed) {
      frameId = window.requestAnimationFrame(step)
      return
    }
    if (offset >= len) {
      window.cancelAnimationFrame(frameId)
      callback?.(null, true, timestamp - startTime)
      return
    }
    beginTime = timestamp + speed
    if (forwards) {
      offset++;
      // if (offset >= len) {
      //   ++skipCount;
      //   if (skipCount === skipDelay) {
      //     forwards = false;
      //     skipCount = 0;
      //   }
      // }
    } else {
      offset--;
      if (offset === 0) {
        forwards = true;
      }
    }
    part = word.substr(0, offset);
    callback?.(part, false)
    frameId = window.requestAnimationFrame(step)
  }
  frameId = window.requestAnimationFrame(step)
  return control
}
